import { Edit, Eye, Plus, Shield, Trash2 } from "lucide-react";

import DataTable from "../../../components/shared/DataTable";
import { Checkbox } from "../../../components/ui/checkbox";

const PermissionTable = ({
  screens,
  permissions,
  onPermissionChange,
  onSelectAllColumn,
  defaultPermissions,
  userPermissions,
  isSuperAdmin
}) => {
  const permTypes = [
    { id: "create", label: "Create", icon: Plus },
    { id: "read", label: "Read", icon: Eye },
    { id: "update", label: "Update", icon: Edit },
    { id: "delete", label: "Delete", icon: Trash2 },
    { id: "approve", label: "Approve", icon: Shield }
  ];

  const canEditPerm = (screenId, permType) => {
    if (isSuperAdmin) return true;
    return !!userPermissions?.[screenId]?.[permType];
  };

  const columns = [
    {
      header: "Action",
      accessor: "label",
      isPrimary: true,
      render: (val, screen) => (
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-yale-blue-900 dark:text-slate-100">{val}</span>
        </div>
      )
    },
    ...permTypes.map((type) => ({
      header: type.label,
      filter: type.id !== "approve" ? (
        <div className="shrink-0 flex items-center justify-end">
          <Checkbox
            checked={screens.every((s) => {
              const isSupported = s.actions ? s.actions.includes(type.id) : true;
              if (!isSupported) return true;
              return permissions[s.id] && permissions[s.id][type.id];
            })}
            onCheckedChange={(checked) => onSelectAllColumn(type.id, !!checked)}
            title={`Select all ${type.label}`}
            className="border-slate-300 dark:border-yale-blue-700 shrink-0"
            disabled={!isSuperAdmin && !screens.some((s) => canEditPerm(s.id, type.id))}
          />
        </div>
      ) : null,
      accessor: type.id,
      noTruncate: true,
      render: (_, screen) => {
        const isSupported = screen.actions ? screen.actions.includes(type.id) : type.id !== "approve" || screen.id === "invoice";
        if (!isSupported) {
          return null;
        }
        return (
          <div className="flex justify-center shrink-0">
            <Checkbox
              checked={
                permissions[screen.id] && typeof permissions[screen.id][type.id] !== "undefined"
                  ? !!permissions[screen.id][type.id]
                  : !!defaultPermissions[screen.id]?.[type.id]
              }
              onCheckedChange={() => onPermissionChange(screen.id, type.id)}
              className="border-slate-300 dark:border-yale-blue-700 shrink-0"
              disabled={!canEditPerm(screen.id, type.id)}
            />
          </div>
        );
      }
    }))
  ];

  return (
    <div>
      <div className="max-h-[60vh] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-200 dark:scrollbar-thumb-yale-blue-800">
        <DataTable
          columns={columns}
          data={screens}
          emptyStateTitle="No screens defined"
          emptyStateDescription="System modules are not configured correctly."
          innerScroll={false}
        />
      </div>
    </div>
  );
};

export default PermissionTable;
